<div class="dialog-wrapper">
    <div class="dialog-header">
        <img *ngIf="data.result != 'failure'" src="./assets/images/icons/dialog-warning.svg" />
        <img *ngIf="data.result == 'failure'" src="./assets/images/icons/dialog-warning-error.svg"/>

    </div>
    <div class="dialog-body">
        <h4>{{ data.title }}</h4>
        <p class="message" [innerHtml]="data.message"></p>
    </div>
    <ng-container *ngIf="iscobStatus">
        <div class="dialog-footer">
            <button type="button" class="button-common button40 cobConfirm" clickable (click)="close()"><span>{{
                    data.button[0]}}</span></button>
        </div>
    </ng-container>
    <ng-container *ngIf="!iscobStatus">
            <div class="dialog-footer">
                <button type="button" class="button-common button40" clickable (click)="close()"><span>{{
                        data.button[0]}}</span></button>
            </div>
    </ng-container>
</div>